export const filterLabel = {
  default: '',
  created_at_gteq: 'Data de criação inicial',
  created_at_lteq: 'Data de criação final',
  city_id_eq: 'Cidade',
  days_without_usage_gteq: "Dias sem compra",
  product_id_eq: 'Produto',
  equipment_category_id_eq: "Tipo do equipamento",
  equipment_status_eq: "Status do equipamento",
  client_branch_id_eq: 'Filial',
  with_branch_and_descendants_is: 'Filiais a baixo dessa também',
  client_equipment_id_eq: 'Equipamento',
  property_kind_eq: "Tipo de propiedade",
  usage_kind_eq: "Tipo de uso",
  closed_at_gteq: 'Data de fechamento inicial',
  closed_at_lteq: 'Data de fechamento final',
  due_at_gteq: 'Date de vencimento inicial',
  due_at_lteq: 'Date de vencimento final',
  overdue_is: 'Apenas faturas vencidas',
  geo_type_eq: 'Tipo de localização',
  geo_id_eq: 'Localização',
};
